import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {DeliveriesDialogService} from "../../services/deliveries-dialog-service.service";
import {ServicesService} from "../../services/services-service.service";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {ServiceType} from "../../types/service.type";

export class RecurringServicesViewCtrl implements IController {
  accountId?: string;
  selectedIds: string[];
  branchIds: string[];
  accountIds: string[];
  tags?: string[];
  resourceIds?: string[];
  serviceAreaIds?: string[];
  serviceTypes: ServiceType[];
  hasResourceAllocation: boolean;
  recurringType: boolean;
  weekDays: any;
  taskAccountIds: string;
  accountPickup: boolean;
  accountDropoff: boolean;
  queryString: string;

  private readonly siteId: any;
  private loadLimit: number;
  private recurringServicesRef: any;

  public infiniteScroll: any;
  public filterConfig: any;

  /* @ngInject */
  constructor(private deliveriesDialogService: DeliveriesDialogService, private $recurringServices, private $infiniteScroll,
              private servicesService: ServicesService, private splitService, private $log, private $state) {
    this.siteId = splitService.getSiteId();
    this.loadLimit = 20;
    this.recurringServicesRef = this.$recurringServices();
  }

  $onInit() {
    if (!this.selectedIds) {
      this.selectedIds = [];
    }

    this.filterConfig = {
      includeFilters: [
        SiteFiltersType.branchIds,
        SiteFiltersType.accountIds,
        SiteFiltersType.tags,
        SiteFiltersType.resourceIds,
        SiteFiltersType.serviceAreaIds,
        SiteFiltersType.serviceTypes,
        SiteFiltersType.hasResourceAllocation,
        SiteFiltersType.recurringType,
        SiteFiltersType.weekDays,
        SiteFiltersType.taskAccountIds,
        SiteFiltersType.accountPickup,
        SiteFiltersType.accountDropoff
      ],
      bringozFilters: {
        [SiteFiltersType.branchIds]: this.branchIds || [],
        [SiteFiltersType.accountIds]: this.accountIds || [],
        [SiteFiltersType.tags]: this.tags || [],
        [SiteFiltersType.resourceIds]: this.resourceIds || [],
        [SiteFiltersType.serviceAreaIds]: this.serviceAreaIds || [],
        [SiteFiltersType.serviceTypes]: this.serviceTypes || [],
        [SiteFiltersType.hasResourceAllocation]: this.hasResourceAllocation,
        [SiteFiltersType.recurringType]: this.recurringType,
        [SiteFiltersType.weekDays]: this.weekDays || [],
        expirationDateAfter: undefined,
        [SiteFiltersType.taskAccountIds]: this.taskAccountIds || [],
        [SiteFiltersType.accountPickup]: this.accountPickup || true,
        [SiteFiltersType.accountDropoff]: this.accountDropoff || true,
      },
      queryString: this.queryString
    };

    if (this.accountId) {
      this.filterConfig.accountIds = [this.accountId];
    }

    this.recurringServicesRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.recurringServicesRef, this.loadLimit, {getFullData: true});
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


  onQueryChange(queryString) {
    this.filterConfig.queryString = queryString;
    this._setStateParams();
    this._query();
  }

  onFiltersChange(filters) {
    // Set Filters
    this.filterConfig.bringozFilters = filters;

    // Reload deliveries by the new query
    this._query();

    // Set query params for the view
    // this._setStateParams();
  }

  onSelectedIdsChange(ids) {
    this.selectedIds = ids;
  }

  onExpirationDateChange(date) {
    this.filterConfig.bringozFilters.expirationDateAfter = date;
    this._query();
  }

  onCreateRecurringService($event, serviceType) {
    this.deliveriesDialogService.createRecurringService($event, serviceType, this.accountId)
      .then((recurringServicePayload) => {
        this._createRecurringService(recurringServicePayload);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onImportRecurringServices($event) {
    this.$state.go('import-recurring-services');
  }

  onEditService(service, $event) {
    this.deliveriesDialogService.editRecurringService($event, service)
      .then((editedService) => {
        this._updateRecurringService(editedService);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onDuplicateService(service, $event) {
    this.deliveriesDialogService.editRecurringService($event, service, true)
      .then((recurringServicePayload) => {
        this._createRecurringService(recurringServicePayload);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onDeleteService(id) {
    this.onDeleteServices([id]);
  }

  onDeleteServices(serviceIds) {
    this.servicesService.deleteRecurringServices(serviceIds)
      .then((deletedServices: any) => {
        this._query();
        this.selectedIds = [];
      })
  }

  // ******************************
  //        Private methods
  // ******************************

  private _getQueryPayload() {
    let accountFromLocationIds = [];
    let accountToLocationIds = [];

    if (!!this.filterConfig.bringozFilters.accountPickup) {
      accountFromLocationIds = accountFromLocationIds.concat(this.filterConfig.bringozFilters.taskAccountIds)
    }

    if (!!this.filterConfig.bringozFilters.accountDropoff) {
      accountToLocationIds = accountToLocationIds.concat(this.filterConfig.bringozFilters.taskAccountIds)
    }

    return {
      query: this.filterConfig.queryString,
      tags: this.filterConfig.bringozFilters.tags,
      resourceIds: this.filterConfig.bringozFilters.resourceIds,
      accountIds: this.filterConfig.bringozFilters.accountIds,
      branchIds: this.filterConfig.bringozFilters.branchIds,
      serviceAreaIds: this.filterConfig.bringozFilters.serviceAreaIds,
      serviceTypes: this.filterConfig.bringozFilters.serviceTypes,
      scheduleFrequency: this.filterConfig.bringozFilters.recurringType,
      byWeekDay: this.filterConfig.bringozFilters.weekDays,
      expirationDateAfter: this.filterConfig.bringozFilters.expirationDateAfter,
      noResourceAllocation: this.filterConfig.bringozFilters.hasResourceAllocation === undefined ? undefined : !this.filterConfig.bringozFilters.hasResourceAllocation,
      accountFromLocationIds: accountFromLocationIds.length ? accountFromLocationIds : undefined,
      accountToLocationIds: accountToLocationIds.length ? accountToLocationIds : undefined,
      limit: this.loadLimit
    };
  }

  private _query() {
    this.recurringServicesRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      }, (resp) => {
        this.$log.debug('Fail to $query', resp);
      });
  }

  private _createRecurringService(recurringService) {
    this.servicesService.createRecurringService(recurringService)
      .then((createdRecurringService) => {
        this._query();
      })
  }

  private _updateRecurringService(recurringService) {
    this.servicesService.updateRecurringService(recurringService.id, recurringService)
      .then((updatedRecurringService) => {
        this._query();
      })
  }

  private _setStateParams() {
    this.$state.go('.', {
      queryString: this.filterConfig.queryString,
    }, {notify: false, reload: false, location: 'replace'});
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('recurringServicesView', {
    bindings: {
      queryString: '<?',
      accountId: '<?',
      selectedIds: '<?',
      branchIds: '<?',
      accountIds: '<?',
      tags: '<?',
      resourceIds: '<?',
      serviceAreaIds: '<?'
    },
    template: require('./recurring-services-view.html').default,
    controller: RecurringServicesViewCtrl
  });
